import _ from 'lodash'
import type {PS, Pointer} from '@wix/document-services-types'
import slots from '../../slots/slots'

const BLOCKS_HOST_COMPONENT_TYPE = 'wysiwyg.viewer.components.RefComponent'
const BLOCKS_DEFAULT_SLOT_ROLE = 'slot'

function cleanupCompsInSlots(ps: PS, compPointer: Pointer): void {
    if (compPointer) {
        let hostComp
        const parentPointer = ps.pointers.components.getParent(compPointer)

        if (parentPointer) {
            hostComp = ps.dal.get(parentPointer)
        }

        if (hostComp?.componentType && hostComp.slotsQuery) {
            if (ps.extensionAPI.schemaAPI.isSchemaCollectionRegistered(hostComp?.componentType)) {
                return
            }

            const slotsData = slots.getSlotsData(ps, parentPointer)

            if (!_.isEmpty(slotsData)) {
                for (const slotRole in slotsData) {
                    if (slotsData[slotRole].id === compPointer.id) {
                        slots.removeInternal(ps, parentPointer, slotRole, true)
                        return
                    }
                }
            }
        }

        if (hostComp?.componentType === BLOCKS_HOST_COMPONENT_TYPE) {
            // In case of Blocks, actual parent isn't RefComponent, but a SlotPlaceholder
            const slotPlaceholderPointer = ps.extensionAPI.slots.getPluginParent(compPointer)

            if (slotPlaceholderPointer) {
                slots.removeInternal(ps, slotPlaceholderPointer, BLOCKS_DEFAULT_SLOT_ROLE, true)
            }
        }
    }
}

function cleanupCompsInSlotsInRemoval(ps: PS, compPointer: Pointer, deletingParent: boolean): void {
    if (deletingParent) {
        return
    }

    return cleanupCompsInSlots(ps, compPointer)
}

export default {cleanupCompsInSlots, cleanupCompsInSlotsInRemoval}
